/**
 * @Author: Klaudie <klaudie@foxprofi.cz>
 */

import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { useUIStore } from '@/stores/uiStore'
import { cn } from '@/lib/utils'

export function AppLayout() {
    const { sidebarCollapsed } = useUIStore()

    return (
        <div className="min-h-screen bg-background">
            <Sidebar />

            <div
                className={cn(
                    'transition-all duration-300',
                    sidebarCollapsed ? 'ml-16' : 'ml-60'
                )}
            >
                <Header />

                <main className="min-h-[calc(100vh-4rem)]">
                    <Outlet />
                </main>
            </div>
        </div>
    )
}
